import { Component, Input, TemplateRef } from '@angular/core';
import { ModalRef } from '@app/core/services/core-modal.service';

/**
 * Hosts a parent TemplateRef inside CoreModal.
 * The template keeps the declaring component as binding context.
 */
@Component({
  selector: 'core-template-modal',
  templateUrl: './core-template-modal.component.html',
  styleUrls: ['./core-template-modal.component.scss'],
  standalone: false,
})
export class CoreTemplateModalComponent {
  @Input() modalRef?: ModalRef;
  @Input() modalData?: TemplateRef<unknown>;
  @Input() template?: TemplateRef<unknown>;

  get outlet(): TemplateRef<unknown> | undefined {
    return this.template ?? this.modalData;
  }
}
